import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { _3_DAYS } from "../../../constants/durations";
import { useSpace } from "../../../hooks/useSpace";
import { keys as remindersKeys } from "../../reminders/api/keys";

async function fetchProviderRemindersCount(providerId: string, spaceId: string): Promise<number> {
  const { count, error } = await apiClient
    .from('reminders')
    .select('*', { count: 'exact', head: true })
    .eq('space_id', spaceId)
    .eq('provider_id', providerId)
    .eq('is_completed', false);

  if (error) {
    throw error;
  }

  return count ?? 0;
}

export default function useGetProviderRemindersCount(providerId: string | undefined) {
  const { currentSpace } = useSpace();
  const params = { provider_id: providerId ?? '', is_completed: false };

  return useQuery({
    queryKey: remindersKeys.listCount(params),
    queryFn: () => fetchProviderRemindersCount(providerId!, currentSpace!.id),
    enabled: !!providerId && !!currentSpace?.id,
    staleTime: _3_DAYS,
  });
}
